import { render } from "./ClickEffect.vue?vue&type=template&id=49ad2b07&scoped=true&ts=true"
import script from "./ClickEffect.vue?vue&type=script&lang=ts"
export * from "./ClickEffect.vue?vue&type=script&lang=ts"

import "./ClickEffect.vue?vue&type=style&index=0&id=49ad2b07&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ad2b07"]])

export default __exports__